<template>
  <div class="mb-1">
    <alert ref="alert"/>
    <div class="container-fluid">
      <b-row class="mt-2 flex-nowrap" v-if="!flagAsScenarioPicker">
        <b-col class="text-left" cols="1">
          <h3>Scenarios</h3>
        </b-col>
        <b-col class="text-right">
          <b-btn
            v-if="!flagModeLocalWorkflow && !flagChangesNotSaved && scenarioModifiedIdx.length == 0"
            variant="info"
            class="text-nowrap mr-1"
            @click="showRemoveModal"
          >
            Remove
          </b-btn>
          <b-modal
            v-model="flagModalRemoveScenariosVisible"
            ok-variant="primary"
            scrollable
            :centered="true"
            :hide-header="true"
            :hide-footer="true"
          >
            <remove-scenarios
              :scenarios="scenariosToShowInRemoveModal"
              :loading="loadingAllScenarios"
              @remove="removeScenarios"
              @cancel="flagModalRemoveScenariosVisible = false"
            />
          </b-modal>

          <!-- ################################################## -->
          <!-- region Share -->
          <b-btn
            v-if="this.$store.getters.isAdmin && !flagModeLocalWorkflow && !flagChangesNotSaved && scenarioModifiedIdx.length == 0"
            variant="info"
            class="text-nowrap mr-1"
            @click="showShareModal"
          >
            Share
          </b-btn>
          <b-modal
            size="xl"
            v-model="flagModalShareScenariosVisible"
            ok-variant="primary"
            scrollable
            :centered="true"
            :hide-header="true"
            :hide-footer="true"
          >
            <share-scenarios
              :scenarios="scenariosToShowInRemoveModal"
              @share="shareScenarios"
              @cancel="flagModalShareScenariosVisible = false"
            />
          </b-modal>
          <!-- endregion Share -->
          <!-- ################################################## -->
          <!-- ################################################## -->
          <!-- region Chart -->
          <b-btn
            v-if="this.$store.getters.isAdmin && !flagModeLocalWorkflow && !flagChangesNotSaved && scenarioModifiedIdx.length == 0"
            variant="info"
            class="text-nowrap mr-1"
            @click="showChartModal"
          >
            Chart
          </b-btn>
          <b-modal
            size="xxl"
            v-model="flagModalChartScenariosVisible"
            ok-variant="dark"
            scrollable
            :centered="true"
            :hide-header="true"
            ok-only
            ok-title="Close"
            :hide-footer="false"
          >
            <chart-scenarios
              :scenarios="scenariosToShowInRemoveModal"
              @cancel="flagModalChartScenariosVisible = false"
            />
          </b-modal>
          <!-- endregion Chart -->
          <!-- ################################################## -->
          <label class="file-select" v-if="!flagModeLocalWorkflow && !flagChangesNotSaved && scenarioModifiedIdx.length == 0">
            <div class="btn btn-info text-nowrap mr-1" :class="{'disabled': flagChangesNotSaved || scenarioModifiedIdx.length > 0}">
              <span>Load from CL-RAMP</span>
            </div>
            <input ref="fileInputCl" id="xlsx_select_cl" type="file" @change="loadCoreLogicScenario" :disabled="flagChangesNotSaved || scenarioModifiedIdx.length > 0"/>
          </label>
          <label class="file-select" v-if="!flagModeLocalWorkflow && !flagChangesNotSaved && scenarioModifiedIdx.length == 0">
            <div class="btn btn-info text-nowrap mr-1" :class="{'disabled': flagChangesNotSaved || scenarioModifiedIdx.length > 0}">
              <span>Load from XLSX</span>
            </div>
            <input ref="fileInput" id="xlsx_select" type="file" @change="loadScenarios" :disabled="flagChangesNotSaved || scenarioModifiedIdx.length > 0"/>
          </label>
          <b-btn variant="info" class="text-nowrap mr-1" @click="showSaveOptionsModal" :disabled="!flagChangesNotSaved">Save</b-btn>
          <b-btn variant="outline-info" class="text-nowrap mr-1" @click="refreshDataFromBackend">Refresh</b-btn>
          <b-modal
            v-model="saveOptionsModalShow"
            ok-variant="primary"
            scrollable
            :centered="true"
            :hide-header="true"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
          >
            <save-options @save="onSaveOptionSelected" @cancel="hideSaveOptionsModal"/>
          </b-modal>
        </b-col>
      </b-row>
    </div>
    <b-container fluid>
      <b-row class="flex-nowrap" :class="{'justify-content-between': flagAsScenarioPicker}">
        <b-col cols="6" class="p-0">
          <div class="scrollable-table-wrapper scenario-list scr-thin">
            <div class="scr-tbl-cont">
              <table class="pct-w-100 text-nowrap" :class="{'vh-h-70': flagAsScenarioPicker, 'vh-h-75': !flagAsScenarioPicker}">
                <thead class="header">
                <tr class="cursor-pointer">
                  <th @click="doSortFilteredData('ScenarioName')" class="pct-w-30">
                    Scenario
                    <span v-if="filtersSorter.ascending && filtersSorter.field === 'ScenarioName'">&uArr;</span>
                    <span v-if="!filtersSorter.ascending && filtersSorter.field === 'ScenarioName'">&dArr;</span>
                  </th>
                  <th @click="doSortFilteredData('DealName')" class="pct-w-30">
                    Deal
                    <span v-if="filtersSorter.ascending && filtersSorter.field === 'DealName'">&uArr;</span>
                    <span v-if="!filtersSorter.ascending && filtersSorter.field === 'DealName'">&dArr;</span>
                  </th>
                  <th @click="doSortFilteredData('Vendor')" class="pct-w-30">
                    Vendor
                    <span v-if="filtersSorter.ascending && filtersSorter.field === 'Vendor'">&uArr;</span>
                    <span v-if="!filtersSorter.ascending && filtersSorter.field === 'Vendor'">&dArr;</span>
                  </th>
                  <th class="pct-w-10">&nbsp;</th>
                </tr>
                <tr>
                  <th class="pct-w-30">
                    <b-form-group>
                      <b-form-select v-model="selectedScenario" :disabled="this.scenarioModifiedIdx.length > 0">
                        <option :value="null">All</option>
                        <option v-for="scenarioName of scenarioNamesForAvailableUserScenarios" :key="scenarioName" :value="scenarioName">{{ scenarioName }}</option>
                      </b-form-select>
                    </b-form-group>
                  </th>
                  <th class="pct-w-30">
                    <b-form-group>
                      <b-form-select v-model="selectedDeal" :disabled="this.scenarioModifiedIdx.length > 0">
                        <option :value="null" v-if="!flagAsScenarioPicker">All</option>
                        <option :value="''">Not deal specific</option>
                        <option v-for="dealName of dealNamesForAvailableUserScenarios" :key="dealName" :value="dealName">{{ dealName }}</option>
                      </b-form-select>
                    </b-form-group>
                  </th>
                  <th class="pct-w-30">
                    <b-form-group>
                      <b-form-select v-model="selectedVendor" :disabled="this.scenarioModifiedIdx.length > 0">
                        <option :value="null">All</option>
                        <option :value="''">Not vendor specific</option>
                        <option v-for="vendor of vendorsForAvailableUserScenarios" :key="vendor" :value="vendor">{{ vendor }}</option>
                      </b-form-select>
                    </b-form-group>
                  </th>
                  <th class="pct-w-10">
                    <b-form-group>
                      <b-btn
                        title="Clear filters"
                        variant="info"
                        style="font-size: 1em !important;"
                        class=""
                        @click="doFilterReset(false)"
                        :disabled="this.scenarioModifiedIdx.length > 0"
                      >&#9003;
                      </b-btn>
                    </b-form-group>
                  </th>
                </tr>
                </thead>
                <tbody v-if="filteredScenarios.length">
                <tr
                  v-for="(s, i) in filteredScenarios"
                  :key="i"
                  @click="showOneScenario(i)"
                  class="row-filtered-scenario"
                  :class="{
              'selected': displayedScenariosIndexes.includes(i)
            }"
                  style="cursor: pointer;"
                >
                  <td class="pct-w-30 text-nowrap text-center">{{ s.ScenarioName || '---' }}</td>
                  <td class="pct-w-30 text-nowrap text-center">{{ s.DealName || '---' }}</td>
                  <td class="pct-w-40 text-nowrap text-center" colspan="2" style="word-wrap: break-word">{{ s.Vendor || '---' }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
        <b-col cols="auto" class="p-0 ml-5">
          <div v-for="index in displayedScenariosIndexes" :key="filteredScenarios[index].Id + '_' + index" style="width: 450px;" class="">
            <scenario-table
              :scenario="filteredScenarios[index]"
              :flagAsScenarioPicker="flagAsScenarioPicker"
              :index="index"
              :flagModeLocalWorkflow="flagModeLocalWorkflow"
              @removeScenario="removeScenario"
              @updateScenario="updateScenario"
              @addScenarioToListOfModified="addScenarioToListOfModified"
              @clearListOfModified="clearListOfModified"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-row v-if="flagAsScenarioPicker" class="text-right mt-3">
      <b-col cols="6" class="p-0">
        <b-button
          :disabled="displayedScenariosIndexes.length <= 0"
          @click="pickerOk"
          variant="primary"
          class="ml-1"
        >Choose
        </b-button>
        <b-button
          variant="outline-info"
          @click="pickerCancel"
          class="ml-1"
        >Cancel
        </b-button>
      </b-col>
      <b-col>&nbsp;<div>&nbsp; &nbsp;</div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service                                           from '../../services/HttpRequestService';
import Alert                                             from '../Alert';
import {isNumericArrayValid, sortArray, isNotEmptyArray} from '@/utilities/ArrayUtils';
import * as XLSX                                         from 'xlsx';
import Scenario                                          from './Scenario';
import ScenarioTable                                     from './ScenarioTable';
import graphLineChart                                    from '@/components/common/graphLineChart';
import RemoveScenarios                                   from './RemoveScenarios';
import ShareScenarios                                    from './ShareScenarios';
import ChartScenarios                                    from './ChartScenarios';
import SaveOptions                                       from './SaveOptions';
import {TRACE_ERROR}                                     from '@/constants';
import ManagerRequest                                    from "@/services/ManagerRequest";
import ObjSpinnerState                                   from "@/components/common/spinner/ObjSpinnerState";

export default {
  props: {
    flagAsScenarioPicker: {
      type:    Boolean,
      default: false
    },
    pSelectedDealName:    {
      type:    String | Array,
      default: null
    }
  },
  data() {
    return {
      scenarioNamesForAvailableUserScenarios: [],
      dealNamesForAvailableUserScenarios:     [],
      vendorsForAvailableUserScenarios:       [],
      selectedScenario:                       null,
      selectedDeal:                           null,
      selectedVendor:                         null,
      allScenarios:                           [],
      filteredScenarios:                      [],
      scenarioModifiedIdx:                    [],
      scenariosToAdd:                         [],
      scenariosToRemove:                      [],
      loadingAllScenarios:                    false,
      alert:                                  {
        timestamp: 0,
        type:      '',
        msg:       ''
      },
      deals:                                  new Set(),
      flagChangesNotSaved:                    false,
      displayedScenariosIndexes:              [],
      flagModalRemoveScenariosVisible:        false,
      flagModalShareScenariosVisible:         false,
      flagModalChartScenariosVisible:         false,
      saveOptionsModalShow:                   false,
      saveOptionsModalResolve:                null,
      saveOptionsModalReject:                 null,
      flagApplyFilter:                        false,
      shownScenario:                          null,
      filtersSorter:                          {
        field:     'ScenarioName',
        ascending: true
      },
      flagModeLocalWorkflow:                  false,
      graphLineChartData:                     [],
      ObjSpinnerState
    };
  },
  async created() {
    this.ObjSpinnerState.isOn = true;
    await this.getAllUserScenarios();
    this.doFilterReset(false);
    this.deals                = new Set(this.dealNamesForAvailableUserScenarios.slice());
    this.ObjSpinnerState.isOn = false;
    if (this.flagAsScenarioPicker) {
      if (this.pSelectedDealName) {
        if (typeof this.pSelectedDealName === 'string') {
          this.selectedDeal = this.pSelectedDealName;
        } else if (Array.isArray(this.pSelectedDealName)) {
          this.selectedDeal = this.pSelectedDealName[0];
        }

      }
    }
  },
  computed:   {
    flagAllScenariosMustBeShownInRemoveModal() {
      return !this.filteredScenarios.length && !this.flagApplyFilter;
    },
    scenariosToShowInRemoveModal() {
      const scenarios = this.flagAllScenariosMustBeShownInRemoveModal
        ? this.allScenarios
        : this.filteredScenarios;
      return scenarios.filter(({Id}) => Boolean(Id));
    }
  },
  watch:      {
    // #####
    // region Filters
    selectedScenario() {
      this.doFilterApply();
    },
    selectedDeal() {
      this.doFilterApply();
    },
    selectedVendor() {
      this.doFilterApply();
    }
    // #####
    // endregion Filters
  },
  methods:    {
    async refreshDataFromBackend() {
      if (!this.modifiedListOkayToProceed()) return;
      await this.getAllUserScenarios();
      this.doFilterReset(false);
      this.flagModeLocalWorkflow = false;
      this.flagChangesNotSaved   = false;
      this.scenarioModifiedIdx   = [];
    },
    async showOneScenario(indexInFilteredScenario) {
      if (this.displayedScenariosIndexes.includes(indexInFilteredScenario)) {
        return;
      }
      if (!this.modifiedListOkayToProceed()) return;
      if (!this.flagModeLocalWorkflow) {
        const id                                        = this.filteredScenarios[indexInFilteredScenario].Id;
        this.filteredScenarios[indexInFilteredScenario] =
          await (
            new ManagerRequest(
              service.getUserScenarioById,
              service,
              this.filteredScenarios[indexInFilteredScenario]
            )
          )
            .do(id);
      }
      this.displayedScenariosIndexes = [indexInFilteredScenario];
      //this.graphDataPrepare(this.filteredScenarios[indexInFilteredScenario]);
    },
    addScenarioToListOfModified(indexInFilteredScenarios) {
      if (!this.flagModeLocalWorkflow) {
        this.scenarioModifiedIdx = [indexInFilteredScenarios];
      }
    },
    clearListOfModified() {
      this.scenarioModifiedIdx = [];
    },
    modifiedListOkayToProceed() {
      if (this.scenarioModifiedIdx.length) {
        if (confirm('Current scenario is modified. Discard changes?')) {
          this.clearListOfModified();
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    loopAllScenarios() {
      if (this.flagApplyFilter) {
        this.filteredScenarios = [];
      } else {
        this.filteredScenarios = this.allScenarios;
      }
      // #####
      const oScenarios = {};
      const oDeals     = {};
      const oVendors   = {};
      // ##################################################
      for (let s of this.allScenarios) {
        if (this.flagApplyFilter) {
          // ###############
          // region Filter
          if (
            (this.selectedScenario === null || this.selectedScenario === s.ScenarioName) &&
            (this.selectedDeal === null || this.selectedDeal === s.DealName) &&
            (this.selectedVendor === null || this.selectedVendor === s.Vendor)
          ) {
            this.filteredScenarios.push(s);
            // #####
            if (s.ScenarioName) {
              oScenarios[s.ScenarioName] = 1;
            }
            if (s.DealName) {
              oDeals[s.DealName] = 1;
            }
            if (s.Vendor) {
              oVendors[s.Vendor] = 1;
            }
          }
          // endregion Filter
          // ###############
        } else {
          if (s.ScenarioName) {
            oScenarios[s.ScenarioName] = 1;
          }
          if (s.DealName) {
            oDeals[s.DealName] = 1;
          }
          if (s.Vendor) {
            oVendors[s.Vendor] = 1;
          }
        }
      }
      // ##################################################
      this.filteredScenarios                      = sortArray(this.filteredScenarios, this.filtersSorter.ascending, this.filtersSorter.field);
      this.scenarioNamesForAvailableUserScenarios = sortArray(Object.keys(oScenarios));
      this.dealNamesForAvailableUserScenarios     = sortArray(Object.keys(oDeals));
      this.vendorsForAvailableUserScenarios       = sortArray(Object.keys(oVendors));
      this.displayedScenariosIndexes              = [];
      //#####
      // Re-define list of available deals.
      if (this.flagAsScenarioPicker) {
        if (typeof this.pSelectedDealName === 'string') {
          this.dealNamesForAvailableUserScenarios = [this.pSelectedDealName].slice();
        } else if (Array.isArray(this.pSelectedDealName)) {
          this.dealNamesForAvailableUserScenarios = this.pSelectedDealName;
        }

      }
      //#####
    },
    doSortFilteredData(field) {
      const ascending              = this.filtersSorter.field === field
        ? !this.filtersSorter.ascending
        : true;
      this.filtersSorter.field     = field;
      this.filtersSorter.ascending = ascending;
      this.doFilterApply();
    },
    async getAllUserScenarios() {
      this.flagModeLocalWorkflow = false;
      this.allScenarios          =
        await (new ManagerRequest(service.getUserScenariosNoVectors, service, []))
          .do();
    },
    showRemoveModal() {
      this.flagModalRemoveScenariosVisible = true;
    },
    showShareModal() {
      this.flagModalShareScenariosVisible = true;
    },
    showChartModal() {
      this.flagModalChartScenariosVisible = true;
    },
    doFilterApply(flagApplyFilter = true) {
      this.flagApplyFilter = flagApplyFilter;
      this.loopAllScenarios();
    },
    doFilterReset(flagApplyFilter = false) {
      if (!this.modifiedListOkayToProceed()) return;
      this.selectedScenario = null;
      this.selectedVendor   = null;
      //#####
      //Reset logic if in pop-up.
      if (this.flagAsScenarioPicker) {
        if (this.pSelectedDealName) {
          if (typeof this.pSelectedDealName === 'string') {
            this.selectedDeal = this.pSelectedDealName;
          } else if (Array.isArray(this.pSelectedDealName)) {
            this.selectedDeal = this.pSelectedDealName[0];
          }
          flagApplyFilter = true;
        }
      } else {
        this.selectedDeal = null;
      }
      //#####
      this.doFilterApply(flagApplyFilter);
    },
    addScenario(scenarios) {
      this.scenariosToAdd            = this.scenariosToAdd.concat(scenarios);
      this.allScenarios              = this.allScenarios.concat(scenarios);
      // this.filteredScenarios = scenarios;
      this.displayedScenariosIndexes = [];
      this.scenariosChanged();
    },
    removeScenario(indexInFilteredScenarios) {
      // if (!confirm('Delete Scenario?')) {
      //   return;
      // }
      let scenarioToRemove = this.filteredScenarios[indexInFilteredScenarios];
      if (!scenarioToRemove.isNew) {
        this.scenariosToRemove.push(scenarioToRemove);
      } else {
        let scenariosToAddIndex = this.scenariosToAdd.findIndex(scenario => {
          return (
            scenario.Owned == scenarioToRemove.Owned &&
            scenario.DealName == scenarioToRemove.DealName &&
            scenario.Vendor == scenarioToRemove.Vendor &&
            scenario.ScenarioName == scenarioToRemove.ScenarioName
          );
        });
        this.scenariosToAdd.splice(scenariosToAddIndex, 1);
      }
      let scenariosIndex             = this.allScenarios.findIndex(scenario => {
        return (
          scenario.Owned == scenarioToRemove.Owned &&
          scenario.DealName == scenarioToRemove.DealName &&
          scenario.Vendor == scenarioToRemove.Vendor &&
          scenario.ScenarioName == scenarioToRemove.ScenarioName
        );
      });
      this.displayedScenariosIndexes = [];
      this.filteredScenarios.splice(indexInFilteredScenarios, 1);
      this.allScenarios.splice(scenariosIndex, 1);
      this.flagChangesNotSaved = true;
      this.doFilterApply();
    },
    async removeScenarios(ids) {
      this.flagModalRemoveScenariosVisible = false;
      try {
        await service.removeUserScenarios(ids);
        const objScenarioIdsToRemove = ids.reduce((acc, id) => ({...acc, [id]: true}), {});
        this.allScenarios            = this.allScenarios.filter(
          scenario => !objScenarioIdsToRemove[scenario.Id]
        );
        this.doFilterApply();
        this.$refs.alert.showAlert('success', 'Successfully removed scenarios');
        return true;
      } catch (err) {
        const errMessage = 'Failed to remove scenarios';
        await service.log(TRACE_ERROR, errMessage, err.stack);
        this.$refs.alert.showAlert('danger', errMessage);
      }
    },
    async shareScenarios(arrScenarioIds, arrUserIds) {
      if (!this.$store.getters.isAdmin) return;
      try {
        this.ObjSpinnerState.isOn = true;
        await service.shareUserScenarios(arrScenarioIds, arrUserIds);
        this.$refs.alert.showAlert('success', 'Successfully shared scenarios');
        this.flagModalShareScenariosVisible = false;
        return true;
      } catch (err) {
        const errMessage = 'Failed to share scenarios';
        await service.log(TRACE_ERROR, errMessage, err.stack);
        this.$refs.alert.showAlert('danger', errMessage);
      } finally {
        this.ObjSpinnerState.isOn = false;
      }
    },
    async updateScenario(index) {
      this.ObjSpinnerState.isOn = true;
      let scenario              = this.filteredScenarios[index];
      if (scenario.DealName != '' && !this.deals.has(scenario.DealName)) {
        this.$refs.alert.showAlert('danger', 'The ' + scenario.DealName + " deal doesn't exist.");
        this.ObjSpinnerState.isOn = false;
        return;
      }
      let error = validateScenario(scenario);
      if (error !== '') {
        this.$refs.alert.showAlert('danger', error || 'Empty or incorrect scenario.');
        this.ObjSpinnerState.isOn = false;
        return;
      }
      let body = {
        ScenarioName: scenario.ScenarioName,
        DealName:     scenario.DealName,
        Vendor:       scenario.Vendor,
        Cpr:          scenario.Cpr,
        Cdr:          scenario.Cdr,
        LossSeverity: scenario.LossSeverity,
        Delinquency:  scenario.Delinquency,
        Shared:       scenario.Shared
      };
      try {
        await service.updateUserScenario(scenario.Id, body);
        this.$refs.alert.showAlert('success', 'Successfully updated scenario');
        //this.graphDataPrepare(this.filteredScenarios[index]);
        this.clearListOfModified();
      } catch (err) {
        await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      } finally {
        this.ObjSpinnerState.isOn = false;
      }
    },
    async saveScenarios(mode) {
      this.ObjSpinnerState.isOn = true;
      try {
        let valid  = true;
        let errMsg = '';
        if (this.scenariosToAdd.length > 0) {
          for (let scenario of this.scenariosToAdd) {
            let error = validateScenario(scenario);
            if (error != '') {
              if (scenario.ScenarioName.length > 0) {
                errMsg += 'Scenario ' + scenario.ScenarioName + ':<br>' + error;
              }
              valid = false;
              continue;
            }
          }
          if (valid) {
            try {
              let res = await service.saveUserScenarios(this.scenariosToAdd, mode);
              this.$refs.alert.showAlert('success', 'Successfully saved scenarios');
              this.flagChangesNotSaved = false;
              this.scenariosToAdd      = [];
              // we have to reload scenarios from database, due to if 'Skip if exists' optoin was selected
              // here will be different data on screen and in the database (CRTHUB-33)
              this.allScenarios = [];
              await this.getAllUserScenarios();
              this.doFilterReset();
              return true;
            } catch (err) {
              await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
              this.$refs.alert.showAlert('danger', err.response.data.Message);
            }
          } else {
            this.$refs.alert.showAlert(
              'danger',
              errMsg || 'Empty or incorrect scenario.',
              4 * errMsg.split('<br>').length
            );
          }
        }
        if (this.scenariosToRemove.length > 0) {
          let ids = this.scenariosToRemove.map(scenario => scenario.Id);
          try {
            let res = await service.removeUserScenarios(ids);
            this.$refs.alert.showAlert('success', 'Successfully removed scenarios');
            this.flagChangesNotSaved = false;
            this.scenariosToRemove   = [];
            return true;
          } catch (err) {
            const errMessage = 'Failed to save scenarios';
            await service.log(TRACE_ERROR, errMessage, err.stack);
            this.$refs.alert.showAlert('danger', errMessage);
          }
        }
        return false;
      } finally {
        this.doFilterApply();
        this.ObjSpinnerState.isOn = false;
      }
    },
    async loadScenarios(e) {
      //TODO-FIX
      if (!this.modifiedListOkayToProceed()) return;
      this.flagModeLocalWorkflow = true;
      let res                    = await service.getDealsNames();
      this.deals                 = new Set(res.data);
      const reader               = new FileReader();
      reader.onload              = e => {
        const bstr = e.target.result;
        try {
          const wb     = XLSX.read(bstr, {type: 'binary'});
          const wsname = wb.SheetNames[0];
          const ws     = wb.Sheets[wsname];
          const data   = XLSX.utils.sheet_to_json(ws, {header: 1});
          if (!Array.isArray(data) || !data.length) {
            this.$refs.alert.showAlert('danger', 'No data in ' + file.name + ' file found.');
            return;
          }
          // ##################################################
          // region Iteration. Scenarios from XLSX
          let scenarios = {};
          for (let x = 1; x < data[2].length; x++) {
            let scenarioName = data[2][x];
            if (scenarioName == '' || scenarioName == undefined) {
              this.$refs.alert.showAlert(
                'danger',
                'Scenario name is required. Please fix the input file.'
              );
              return;
            }
            let dealName = data[1][x];
            if (dealName != undefined && !this.deals.has(dealName)) {
              this.$refs.alert.showAlert(
                'danger',
                'The ' + dealName + " deal doesn't exist. Please fix the input file."
              );
              return;
            }
            let vendor   = data[0][x];
            let scenario = new Scenario(scenarioName, vendor, dealName);
            let key      = scenarioName + '_' + dealName + '_' + vendor;
            if (!scenarios.hasOwnProperty(key)) {
              scenarios[key]       = scenario;
              scenarios[key].Owned = true;
            }
            let type = data[3][x];
            for (let y = 4; y < data.length; y++) {
              if (data[y][x] == undefined) {
                break;
              }
              if (type.toLowerCase() == 'cpr') {
                scenarios[key].Cpr.push(data[y][x]);
              } else if (type.toLowerCase() == 'cdr') {
                scenarios[key].Cdr.push(data[y][x]);
              } else if (type.toLowerCase() == 'sev') {
                scenarios[key].LossSeverity.push(data[y][x]);
              } else if (type.toLowerCase() == 'del') {
                scenarios[key].Delinquency.push(data[y][x]);
              }
            }
            // if (
            //   this.allScenarios.length > 0 &&
            //   this.allScenarios.filter(s => s.ScenarioName + '_' + s.DealName + '_' + s.Vendor == key)
            //     .length
            // ) {
            //   let msg = 'Scenario ' + scenarioName;
            //   msg += dealName == undefined ? '' : ' for ' + dealName + ' deal';
            //   msg += vendor == undefined ? '' : ' created by ' + vendor;
            //   msg += ' already exists.';
            //   this.$refs.alert.showAlert('danger', msg);
            //   return;
            // }
          }
          // endregion Iteration Scenarios from XLSX
          // ##################################################
          this.allScenarios = [];
          this.addScenario(Object.values(scenarios));
          this.doFilterReset();
        } catch (err) {
          this.$refs.alert.showAlert('danger', err.message);
        } finally {
          this.ObjSpinnerState.isOn    = false;
          this.$refs.fileInput.value   = '';
          this.$refs.fileInputCl.value = '';
        }
      };
      try {
        this.ObjSpinnerState.isOn = true;
        reader.readAsBinaryString(e.target.files[0]);
      } finally {
        this.ObjSpinnerState.isOn = false;
      }
    },
    loadCoreLogicScenario(e) {
      if (!this.modifiedListOkayToProceed()) return;
      this.flagModeLocalWorkflow = true;
      const reader               = new FileReader();
      reader.onload              = e => {
        const bstr = e.target.result;
        try {
          const wb     = XLSX.read(bstr, {type: 'binary'});
          const wsname = wb.SheetNames[0];
          const ws     = wb.Sheets[wsname];
          const data   = XLSX.utils.sheet_to_json(ws, {header: 1});
          if (!Array.isArray(data) || !data.length) {
            this.$refs.alert.showAlert('danger', 'No data in ' + file.name + ' file found.');
            return;
          }
          let scenarios    = {};
          let scenarioName = '';
          let dealName     = '';
          let vendor       = '';
          let scenario     = new Scenario(scenarioName, vendor, dealName);
          let key          = scenarioName + '_' + dealName + '_' + vendor;
          if (!scenarios.hasOwnProperty(key)) {
            scenarios[key]       = scenario;
            scenarios[key].Owned = true;
          }
          for (let y = 5; y < data.length; y++) {
            if (data[y][1] == undefined) {
              break;
            }
            scenarios[key].Cpr.push(data[y][1]);
            scenarios[key].Cdr.push(data[y][2]);
            scenarios[key].LossSeverity.push(data[y][3]);
            scenarios[key].Delinquency.push(data[y][4]);
          }
          // if (
          //   this.allScenarios.length > 0 &&
          //   this.allScenarios.filter(s => s.ScenarioName + '_' + s.DealName + '_' + s.Vendor == key)
          //     .length
          // ) {
          //   let msg = 'Scenario ' + scenarioName;
          //   msg += dealName == undefined ? '' : ' for ' + dealName + ' deal';
          //   msg += vendor == undefined ? '' : ' created by ' + vendor;
          //   msg += ' already exists.';
          //   this.$refs.alert.showAlert('danger', msg);
          //   return;
          // }
          this.allScenarios = [];
          this.addScenario(Object.values(scenarios));
          this.doFilterReset();
        } catch (err) {
          this.$refs.alert.showAlert('danger', err.message);
        } finally {
          this.ObjSpinnerState.isOn    = false;
          this.$refs.fileInput.value   = '';
          this.$refs.fileInputCl.value = '';
        }
      };
      try {
        this.ObjSpinnerState.isOn = true;
        reader.readAsBinaryString(e.target.files[0]);
      } finally {
        this.ObjSpinnerState.isOn = false;
      }
    },
    scenariosChanged() {
      this.flagChangesNotSaved = true;
    },
    async onSaveOptionSelected(mode) {
      this.saveOptionsModalShow = false;
      try {
        const result = await this.saveScenarios(mode);
        this.saveOptionsModalResolve(result);
      } catch (error) {
        await service.log(TRACE_ERROR, 'Error occurred saveScenarios', err.stack);
        this.saveOptionsModalReject(error);
      }
    },
    showSaveOptionsModal() {
      this.saveOptionsModalShow = true;
      return new Promise((resolve, reject) => {
        this.saveOptionsModalResolve = data => {
          this.saveOptionsModalReject = null;
          resolve(data);
        };
        this.saveOptionsModalReject  = error => {
          this.saveOptionsModalResolve = null;
          reject(error);
        };
      });
    },
    hideSaveOptionsModal() {
      this.saveOptionsModalShow = false;
      this.saveOptionsModalResolve(true);
    },
    // ##### Left as example, in case of further need. CRTHUB-156
    graphDataPrepare(objScenario) {
      try {
        this.graphLineChartData = [];
        const nameStart         = `${objScenario.ScenarioName}-${objScenario.DealName}-${objScenario.Vendor}`
        this.graphLineChartData = [
          [`${nameStart}:Cdr`].concat(objScenario.Cdr),
          [`${nameStart}:Cpr`].concat(objScenario.Cdr),
          [`${nameStart}:Delinquency`].concat(objScenario.Delinquency),
          [`${nameStart}:LossSeverity`].concat(objScenario.LossSeverity)
        ];
      } catch (e) {
        // Do nothing
      }
    },
    //#################################################
    pickerOk() {
      const index       = this.displayedScenariosIndexes[0];
      const objScenario = this.filteredScenarios[index];
      this.$emit('pickerOk', objScenario);
    },
    pickerCancel() {
      this.$emit('pickerCancel');
    },
    //#################################################
  },
  components: {
    Alert,
    ScenarioTable,
    RemoveScenarios,
    ShareScenarios,
    ChartScenarios,
    SaveOptions,
    graphLineChart
  },
  async beforeRouteLeave(to, from, next) {
    let proceedRouting = true;
    if (this.flagChangesNotSaved) {
      const shouldSave = window.confirm('You have unsaved changes! Do you want to save them?');
      if (shouldSave) {
        proceedRouting = await this.showSaveOptionsModal();
      }
    }
    next(proceedRouting);
  }
}

function validateScenario(scenario) {
  let error = '';
  if (scenario.ScenarioName.length == 0) {
    error = "Scenario name mustn't be empty";
  } else {
    error += validateVector(scenario.Cpr, 'CPR');
    error += validateVector(scenario.Cdr, 'CDR');
    error += validateVector(scenario.LossSeverity, 'Severity');
    error += validateVector(scenario.Delinquency, 'Delinquency');
    return error;
  }
}

function validateVector(vector, vectorType) {
  if (!isNotEmptyArray(vector)) {
    return vectorType + ' vector is empty.<br>';
  }
  if (!isNumericArrayValid(vector)) {
    return vectorType + ' vector contains incorrect values.<br>';
  }
  return '';
}
</script>
<style lang="scss" scoped>
.scrollable-table-wrapper.scenario-list table {
  border: #cacaca solid 1px;
}

.scrollable-table-wrapper.scenario-list tbody td {
  text-wrap: avoid;
  white-space: nowrap !important;
  font-size: 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.2em;
}

.scrollable-table-wrapper.scenario-list .scr-tbl-cont > table > thead > tr,
{
  border-top: 0 solid #17a2b8 !important;
}

#xlsx_select {
  display: none;
}

#xlsx_select_cl {
  display: none;
}

.header {
  caption-side: top;
  text-align: center;
  padding: 0 0;
  color: #fff;
  background-color: #17a2b8;
}

#main-frame {
  height: 82vh;
}

/* region Left Side */
#left-column {
  width: 50%;
  overflow-y: hidden;
  overflow-x: hidden;
}

table#left-table.table td {
  vertical-align: top !important;
}

.row-filtered-scenario:hover {
  background-color: #ebebeb;
}

.row-filtered-scenario.selected {
  background-color: #7f7f7f;
}

.scenarioCell {
  display: inline-block;
  padding: 0.2em;
  vertical-align: top;
}

/* endregion Left Side */
</style>
